import { render, staticRenderFns } from "./m-block-error-card.vue?vue&type=template&id=43517a2d&scoped=true&lang=pug"
import script from "./m-block-error-card.vue?vue&type=script&lang=js"
export * from "./m-block-error-card.vue?vue&type=script&lang=js"
import style0 from "./m-block-error-card.vue?vue&type=style&index=0&id=43517a2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43517a2d",
  null
  
)

export default component.exports